import { Header } from './Header';

export const EmptyRootItem = ({ isArray }: { isArray: boolean }) => {
	return (
		<ul>
			<Header name="root" isArray={isArray} items={0} />
		</ul>
	);
};
